import modelBaseV2 from "../model-base-v2.model";

let siteModel = {
  getManagedSite: () => {
    return modelBaseV2.get('/api/site/managed');
  },

  getManagedSiteByCountry: (countryCode) => {
    return modelBaseV2.get(`/api/site/managed/${countryCode}`);
  },

  getManagedSiteByCountryUser: (countryCode, userId) => {
    return modelBaseV2.get(`/api/site/managed/${countryCode}/${userId}`);
  },

  getByType: function (param) {
    return modelBaseV2.get(`/api/site/search/${param.type}?countryCode=${param.countryCode}`);
  },

  getBUChannelTypesForModelDisplayFlooring: function (week = '') {
    return modelBaseV2.get(`/api/site/buchanneltype/newmodeldisplayflooring?week=${week}`);
  },

  getBUAccountsForModelDisplayFlooring: function (week = '') {
    return modelBaseV2.get(`/api/site/buaccount/newmodeldisplayflooring?week=${week}`);
  },

  getSitesForModelDisplayFlooring: function (week = '') {
    return modelBaseV2.get(`/api/site/newmodeldisplayflooring?week=${week}`);
  },

  getSiteGroupsBySiteGroupCodes: function (siteGroupCodes) {
    siteGroupCodes ||= [];
    return modelBaseV2.post('/api/site/sitegroup', { body: siteGroupCodes });
  },

  getSites: (body) => {
    return modelBaseV2.post('/api/site/search/site', { body });
  }
}

export default siteModel
